import { render, staticRenderFns } from "./origtime_col.vue?vue&type=template&id=4c0eb2ac&scoped=true&"
import script from "./origtime_col.vue?vue&type=script&lang=js&"
export * from "./origtime_col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0eb2ac",
  null
  
)

export default component.exports